import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import OnixCodetablesList from "./OnixCodetablesList";
import { RoleEnum } from "../../types/RoleEnum";
import { RouteGuard } from "../../guards/RouteGuard";
import OnixCodetablesCreate from "./OnixCodetablesCreate";
import OnixCodetablesEdit from "./OnixCodetablesEdit";
function OnixCodetables() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR] },
                React.createElement(OnixCodetablesList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR] },
                React.createElement(OnixCodetablesCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR] },
                React.createElement(OnixCodetablesEdit, null))); } })));
}
export default OnixCodetables;
